import styled from 'styled-components';
import { Row, Col, Divider } from 'antd';

const GREEN_COLOR = '#2CC852';
const YELLOW_COLOR = '#F8D627';
const RED_COLOR = '#E74150';
const PURPLE_COLOR = '#9B54E2';

const RISK_COLOR: Record<number, string> = {
	1: GREEN_COLOR,
	2: YELLOW_COLOR,
	3: RED_COLOR,
	4: PURPLE_COLOR
};

interface ScoreProps {
	$score?: number;
}

export const Container = styled(Row)`
	height: 100%;
	padding: 12px;
	border-radius: 12px;
	background-color: #f8f8f8;
`;

export const Section = styled(Col)`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const ScoreContainer = styled.div<ScoreProps>`
	width: 30%;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 2px solid ${({ $score }) => ($score ? RISK_COLOR[$score] : '#e6e8e8')};
	background-color: ${({ $score }) => ($score ? RISK_COLOR[$score] : 'transparent')};

	span {
		font-weight: 600;
		font-size: 1.5rem;
		color: ${({ $score }) => ($score ? '#FFFFFF' : '#e6e8e8')};
	}
`;

export const DividerWrapper = styled(Divider)`
	height: 100%;
	text-align: center;
	border-left: 2px solid #ececec;
`;
